import React from 'react';
import type {
  ListItemButtonProps} from '@mui/material';
import {
  ListItemButton as MuiListItemButton
} from '@mui/material';

const ListItemButton: React.FC<ListItemButtonProps> = (props) => {
  return <MuiListItemButton {...props}>{props.children}</MuiListItemButton>;
};

export default ListItemButton;
